/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DeviceEventActionAliases {
  AUTOCOMPLETE_DETAIL = 'autocomplete-detail',
  AUTOCOMPLETE_EVENT = 'autocomplete-event',
  AUTOCOMPLETE_SECTOR = 'autocomplete-sector',
  AUTOCOMPLETE_WHITDRAWN_ACTION = 'autocomplete-whitdrawn-action',
  CONTEXTUAL_BAR_EVENT = 'contextual-bar-event',
  DYNAMIC_FIELDS = 'dynamic-fields',
  FETCH_DETAIL = 'fetch-detail',
  FETCH_EVENT = 'fetch-event',
  FETCH_PROFESSIONAL = 'fetch-professional',
  FETCH_SECTOR = 'fetch-sector',
  FETCH_WHITDRAWN_ACTION = 'fetch-whitdrawn-action',
  FIELD_DATE = 'field-date',
  FIELD_DESCRIPTION = 'field-description',
  FIELD_DETAIL = 'field-detail',
  FIELD_DEVICE = 'field-device',
  FIELD_EVENT = 'field-event',
  FIELD_IMMEDIATE_ACTION = 'field-immediate-action',
  FIELD_PROFESSIONAL = 'field-professional',
  FIELD_SECTOR = 'field-sector',
  FIELD_WITHDRAWN_ACTION = 'field-withdrawn-action',
  FIELDSET_DYNAMIC_FIELDS = 'fieldset-dynamic-fields',
  FORM_EVENT = 'form-event',
  FRAGMENT_EVENT = 'fragment-event',
  INPUT_DATE = 'input-date',
  INPUT_PROFESSIONAL = 'input-professional',
  LAYOUT_EVENT = 'layout-event',
  LOCATOR_FIELD_PROFESSIONAL = 'locator-field-professional',
  LOCATOR_PROFESSIONAL = 'locator-professional',
  MAPPER_DETAIL = 'mapper-detail',
  MAPPER_EVENT = 'mapper-event',
  MAPPER_SECTOR = 'mapper-sector',
  MAPPER_WITHDRAWN_ACTION = 'mapper-withdrawn-action',
  PANEL_EVENT = 'panel-event',
  TEXT_AREA_DESCRIPTION = 'text-area-description',
  TEXT_AREA_IMMEDIATE_ACTION = 'text-area-immediate-action',
  TEXT_DETAIL = 'text-detail',
  TEXT_DEVICE = 'text-device',
  TEXT_EVENT = 'text-event',
  TEXT_SECTOR = 'text-sector',
  TEXT_WITHDRAWN_ACTION = 'text-withdrawn-action',
}
export { DeviceEventActionAliases };
